'use client';

import { useState } from 'react';
import PostCard from './PostCard';
import type { BlogCard } from '@/lib/blog-cards';
import type { BlogIndustry } from '@/lib/blog-taxonomy';

type IndustryOption = { key: BlogIndustry; label: string };

/** Latest grid with its industry filter in the section head. Styles: blog-home.css. */
export function LatestGrid({
  posts,
  options,
  title,
  sub,
  subFiltered,
  empty,
  filterLabel,
  allLabel,
}: {
  posts: BlogCard[];
  options: IndustryOption[];
  title: string;
  sub: string;
  /** Contains `{i}` for the industry label. */
  subFiltered: string;
  /** Contains `{i}` for the industry label. */
  empty: string;
  filterLabel: string;
  allLabel: string;
}) {
  const [industry, setIndustry] = useState<BlogIndustry | ''>('');
  const list = posts.filter((p) => !industry || p.industry === industry).slice(0, 6);
  const label = options.find((o) => o.key === industry)?.label ?? '';

  return (
    <>
      <div className="sh">
        <div>
          <h2>{title}</h2>
          <div className="sub">{industry ? subFiltered.replace('{i}', label) : sub}</div>
        </div>
        <label className="filt">
          {filterLabel}
          <span className="sel">
            <select value={industry} onChange={(e) => setIndustry(e.target.value as BlogIndustry | '')}>
              <option value="">{allLabel}</option>
              {options.map((o) => (
                <option key={o.key} value={o.key}>
                  {o.label}
                </option>
              ))}
            </select>
            <svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true">
              <path d="M1 1l4 4 4-4" stroke="#17201F" fill="none" strokeWidth="1.5" />
            </svg>
          </span>
        </label>
      </div>
      <div className="grid">
        {list.length ? (
          list.map((p) => <PostCard key={p.id} post={p} />)
        ) : (
          <div className="empty">{empty.replace('{i}', label)}</div>
        )}
      </div>
    </>
  );
}
